var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-text"},[_c('CustomIcon',{attrs:{"name":_vm.iconName}}),_c('p',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }